import React, { useMemo } from "react";

import PropTypes from "prop-types";
import Breadcrumb from "shared/components/Breadcrumb";
import Product from "shared/components/Product";
import Space from "shared/components/Space";
import { PATHS, ACTIONS_KEY } from "utils/constants";

import Address from "./Address";
import Advancement from "./Advancement";

const ACTIONS = {
  [ACTIONS_KEY.ADDRESS]: Address,
  [ACTIONS_KEY.ADVANCEMENT]: Advancement,
};

const Component = ({ data, folderNum, action, refetch }) => {
  const Action = useMemo(() => ACTIONS[action], [action]);
  return (
    <div>
      <Breadcrumb
        routes={[
          {
            title: "Dossiers",
            route: PATHS.FILE.HOME,
          },
          { title: folderNum, route: "#" },
        ]}
      />
      <Space h={24} />
      <Product
        type="banner"
        data={data}
        folderNum={folderNum}
        activeAction={action}
      />
      <Space h={24} />
      {Object.keys(ACTIONS).includes(action) && (
        <Action data={data} refetch={refetch} />
      )}
    </div>
  );
};

Component.propTypes = {
  action: PropTypes.oneOf(Object.keys(ACTIONS)).isRequired,
  data: PropTypes.object.isRequired,
  folderNum: PropTypes.string.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default Component;
